import { render } from "./ArtistApproval.vue?vue&type=template&id=f26d1e88&ts=true"
import script from "./ArtistApproval.vue?vue&type=script&lang=ts"
export * from "./ArtistApproval.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__